<template>
  <div class="Footer" :class="classes" v-if="visible && isShowFooter">
    <!-- 前半部分 -->
    <div class="top">
      <div class="content">
        <!-- logo -->
        <div class="logo">
          <img
            class="icon-earth"
            :src="require('@/assets/images/logo@3x.png')"
          />

          <h1 class="title">
            {{ $t('Entrega_order__YnnH') /** DiDi Entrega Business */ }}
          </h1>
        </div>
        <div class="top-right">
          <div class="col-item">
            <p class="first-line">
              {{ $t('FoodC_B2C_home_footer_city_title_AAAA') }}
            </p>
            <p class="second-line">
              {{ $t('FoodC_B2C_home_footer_city_Puebla_AAAA') }}
            </p>
          </div>
          <div class="col-item col-3">
            <!-- <p class="first-line">
              {{ $t('FoodC_B2C_home_footer_partner_title_AAAA') }}
            </p> -->
            <a
              class="link first-line"
              :href="`https://www.didi-food.com/${currentLanguage}/mobile-delivery/guide?clientType=796&country=${country}`"
              target="_blank"
              >{{ $t('FoodC_B2C_home_footer_partner_rider_AAAA') }}</a
            >
          </div>
          <div class="col-item col-4">
            <!-- <a
              class="link first-line"
              href="https://mexico.didiglobal.com/"
              target="_blank"
              >{{
                $t('Entrega_order__ozpr', {
                  brand: $t('GDriver_Name_DiDi_Gsik' /** DiDi */),
                })
              }}</a
            > -->
            <a
              class="link first-line"
              href="https://h5.didiglobal.com/silver-bullet-online/dyE9Gg8gUexEQpvgjnNTH"
              target="_blank"
              >{{ $t('FoodC_B2C_home_footer_contact_FAQ_AAAA') }}</a
            >
            <p class="second-line">
              {{ $t('FoodC_B2C_home_footer_contact_more_AAAA') }}
            </p>
            <!-- <a
              class="link second-line"
              :href="`https://www.didi-food.com/${currentLanguage}/contact-us`"
              target="_blank"
              >{{ $t('Entrega_order__jjRu' /** 联系我们 */) }}</a
            > -->
          </div>
        </div>
      </div>
    </div>

    <!-- light 主题时会有分割线 -->
    <!-- <div class="split-line"></div> -->

    <!-- 后半部分 -->
    <div class="bottom">
      <div class="content">
        <div class="first-line">
          <div class="select">
            <!-- 展示语言 -->
            <div class="country-wrapper">
              <i class="icon icon-pc_outlined_earth"></i>
              <el-select
                v-model="currentLanguage"
                placeholder=""
                popper-class="country-wrapper-sel-class"
                @change="handleSwitchLang"
              >
                <el-option
                  v-for="item in languageOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="bottom-right">
            <p class="copyright">Copyright © 2019 didi food Inc.</p>
            <p class="privacidad">
              Privacidad<span>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>Legal
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLocale } from '@/utils/locale';
import { countryAbbreviationFlipMap } from '@/config/countryConfig/country-locale-map';
import { getUrlOrigin } from '@/utils/baseUtil';
import { getLanguageOptionsForCountry } from '@/config/countryConfig/footer';
import { homePageClick } from '@/omega/business/common';
import { getCountry } from '@/utils/index';
import { isH5 } from '@/utils/tools';
import { HOME_NAME } from '@/const/router';

export default {
  name: 'Footer',
  props: {
    theme: {
      type: String,
      default: 'light',
    },
    visible: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    classes() {
      const { theme } = this;
      let classes = [theme ? `Footer--${theme}` : ''];
      return classes;
    },
    country() {
      return getCountry();
    },
    languageOptions() {
      return getLanguageOptionsForCountry(this.country);
    },
    isShowFooter() {
      if (this.$route.name === HOME_NAME) {
        return true;
      } else {
        return !isH5;
      }
    },
  },
  data() {
    return {
      currentCountry: '',
      currentLanguage: getLocale(),
    };
  },
  mounted() {
    this.currentCountry = countryAbbreviationFlipMap[this.country];
  },
  methods: {
    handleSwitchLang(value) {
      // 切换语言埋点
      homePageClick({ click_type: 4, language_type: value });
      const path = `${getUrlOrigin()}/${value}/entrega-business${
        this.$route.fullPath
      }`;
      window.location.href = path;
    },
  },
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss">
.country-wrapper-sel-class {
  margin-bottom: 8px !important;
  border: none !important;
  .popper__arrow {
    display: none !important;
  }

  &.el-popper {
    margin-left: -25px;

    .el-select-dropdown__item {
      color: #999;
    }

    .el-select-dropdown__item.hover,
    .el-select-dropdown__item:hover {
      background-color: #f5f5f7;
    }
  }
}
</style>
